<template>
    <b-form-group style="max-width: 500px">
        <template slot="label">
            <div class="d-flex">
                <div class="font-weight-bold text-muted mr-3">
                    {{ $t('nBox.form.evaluationCategory') }}
                </div>
                <b-badge variant="primary">
                    {{ $t('values.evaluations') }}
                </b-badge>
            </div>
        </template>
        <b-form-select
            size="sm"
            :state="state"
            :value="model"
            :options="options"
            @input="model = $event"
        />
    </b-form-group>
</template>
<script>
import i18n from '@/i18n'
import api from '@/services/api'
export default {
    props: {
        selected: {
            type: [Number, String],
            default: null,
        },
        state: {
            type: Boolean,
            default: null,
        },
    },
    created() {
        this.getCategories()
    },
    data() {
        return {
            model: this.selected,
            categories: [],
        }
    },
    computed: {
        options() {
            return [
                {
                    value: null,
                    text: i18n.t('nBox.selectAnOption'),
                },
                ...this.categories.map(category => {
                    return {
                        value: category.id,
                        text: category.title,
                    }
                }),
            ]
        },
    },
    watch: {
        model() {
            this.$emit('change', this.model)
        },
    },
    methods: {
        getCategories() {
            return api
                .get('categories', {
                    params: {
                        filter: 'id;title',
                    },
                })
                .then(resp => {
                    this.categories = resp.data.data
                })
        },
    },
}
</script>
